import { CellData } from '../cell-data';
import { TableData } from '../table-data';

export class TransposeTableDataTransform {
	public static readonly instance = new TransposeTableDataTransform();

	public transform(data: TableData): TableData {
		const result: CellData[][] = [];
		if (data && data.cells) {
			for (let i = 0; i < data.cells.length; i++) {
				for (let j = 0; j < data.cells[i].length; j++) {
					if (!result[j]) {
						result[j] = [];
					}
					result[j][i] = data.cells[i][j];
				}
			}
		}
		return new TableData(data.headersY, data.headersX, result, data.portfolioData, data.firstColumnTitle, true);
	}
}
